<div class="manual-approval-container">
  <div class="manual-approval-info">
    <div class="info-wrapper" [class.touch-layout]="isTouch">
      <div *ngIf="showImage" class="control-container">
        <div class="product-image">
          <app-product-card-image
            [isOnline]="isOnline"
            [imageThumbnail]="product?.imageThumbnail"
            [productNumber]="product?.productNumber"
            [height]="screenWidth < 1200 && isTouch ? 3.5 : 5.25"
            [width]="screenWidth < 1200 && isTouch ? 3.5 : 5.25"
            [clickable]="false"
          ></app-product-card-image>
        </div>
        <ng-container
          *ngIf="screenWidth >= 1200"
          [ngTemplateOutlet]="manualApprovalContent"
        ></ng-container>
        <button
          data-cy="close-manual-approval-button"
          class="close-manual-approval-button"
          (click)="onCloseManualApproval($event)"
        >
          <ion-icon
            class="close-icon"
            slot="icon-only"
            name="close-outline"
          ></ion-icon>
        </button>
      </div>
      <ng-container
        *ngIf="screenWidth < 1200"
        [ngTemplateOutlet]="manualApprovalContent"
      ></ng-container>
    </div>
  </div>

  <ion-popover
    data-cy="manual-approval-popover"
    class="manual-approval-popover"
    #manualApprovalPopover
    mode="ios"
    arrow="true"
    side="bottom"
    alignment="center"
    [isOpen]="manualApprovalPopoverOpen"
    (didDismiss)="manualApprovalPopoverOpen = false"
    *ngIf="!isTouch"
  >
    <ng-template>
      <app-ellipsis-options-popover
        class="popover-viewport"
        [buttons]="manualApprovalDesktopButtons"
      ></app-ellipsis-options-popover>
    </ng-template>
  </ion-popover>

  <ion-action-sheet
    class="action-sheet-touch"
    mode="ios"
    [buttons]="mobileActionSheetButtons"
    [isOpen]="isMobileSheetOpen"
    (didDismiss)="isMobileSheetOpen = false"
  >
  </ion-action-sheet>
</div>

<ng-template #manualApprovalContent>
  <div class="manual-approval-wrapper">
    <div
      class="manual-approval-label"
      [class.mobile-rail-layout]="!showImage && isTouch && screenWidth < 768"
    >
      {{ 'i18n.lists.pmeList.priceBelowLimit' | translate }}
      <button
        *ngIf="!showImage"
        data-cy="close-manual-approval-button"
        class="close-manual-approval-button"
        (click)="onCloseManualApproval($event)"
      >
        <ion-icon
          class="close-icon"
          slot="icon-only"
          name="close-outline"
        ></ion-icon>
      </button>
    </div>
    <div class="manual-approval-prompt">
      <span
        >{{ 'i18n.lists.pmeList.wouldYouLikeToSubmit' | translate }}&nbsp;</span
      >
      <span class="price-value"
        >{{ product?.easyPricingViewModel?.customPrice | currency }}&nbsp;</span
      >
      <span>{{ 'i18n.lists.pmeList.wouldYouLikeToSubmit2' | translate }}</span>
    </div>
    <div
      class="reason-container"
      [class.mobile-layout]="isTouch && screenWidth < 768"
    >
      <ion-item
        (click)="handleReasonSelection($event)"
        class="reason-dropdown"
        [class.mobile-layout]="isTouch && screenWidth < 768"
        detail="true"
        detail-icon="chevron-down-outline"
      >
        <ion-label>{{
          manualApprovalReason
            ? getReasonText(manualApprovalReason)
            : 'Select reason'
        }}</ion-label>
      </ion-item>
      <ion-button
        (click)="onManualApprovalSubmit($event)"
        [disabled]="!manualApprovalReason"
        class="usf-fill-green-button md button"
        >{{ 'i18n.common.submit' | translate }}</ion-button
      >
    </div>
  </div>
</ng-template>
